<template>
  <div class="form-container" style="position: relative">
    <el-form ref="form" label-position="top" :model="formLabelAlign" label-width="80px" class="order-form">
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item :label="$t('product')" style="width: 100%">
            <el-input class="gray-theme" v-model.number="formLabelAlign.productName" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$t('user_qty')" style="width: 100%">
            <el-input type="number" class="gray-theme" v-model.number="formLabelAlign.userNumber" @input="userqtyChange"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$t('user_month')" style="width: 100%">
            <el-input type="number" class="gray-theme" v-model.number="formLabelAlign.monthNumber" @input="monthChange"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$t('currency')" style="width: 100%">
            <el-select v-model="formLabelAlign.currency" disabled class="gray-theme" style="width: 100%" filterable>
              <el-option v-for="item in currencyListData" :key="item.code" :label="item.code" :value="item.code">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$t('amount')" prop="amount" style="width: 100%">
            <el-input class="gray-theme" v-model.number="formLabelAlign.payableAmount" :disabled="readModel"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import orderApi from '@/apis/order';
export default {
  data() {
    // var checkMoney = (rule, value, callback) => {
    //   if (value === '') {
    //     callback();
    //     return;
    //   }
    //   if (!this.$formValidation.twoPointreg.test(value)) {
    //     callback(new Error('Mony format error '));
    //     return;
    //   }
    //   if (value < 0 || value > 9999999999999.99) {
    //     callback(new Error('Mony format error '));
    //     return;
    //   }
    //   callback();
    // };
    return {
      formLabelAlign: {
        no: '',
        createdTime: '',
        status: '',
        productName: '',
        productId: '',
        userNumber: '',
        monthNumber: '',
        payableAmount: '',
        buyer: '',
        email: '',
        phone: '',
        currency: '',
        company: '',
        paymentdate: '',
        activedate: '',
        deadline: ''
      },
      statusOptions: [
        {
          name: this.$t('submitted'),
          code: 10
        },
        {
          name: this.$t('canceled'),
          code: 20
        },
        {
          name: this.$t('completed'),
          code: 30
        },
        {
          name: this.$t('apply_trial'),
          code: 40
        },
        {
          name: this.$t('on_trial'),
          code: 50
        },
        {
          name: this.$t('trial_reject'),
          code: 80
        }
      ],
      payStatusOptions: [
        {
          name: ' ',
          code: 0
        },
        {
          name: this.$t('unpaid'),
          code: 10
        },
        {
          name: this.$t('paid'),
          code: 20
        },
        {
          name: this.$t('refunded'),
          code: 30
        }
      ],
      currencyListData: []
    };
  },

  props: {
    rowData: {
      type: Object,
      default: () => {}
    },

    readModel: {
      type: Boolean,
      default: true
    }
  },

  components: {},

  computed: {
    ...mapState(['userInfo'])
  },

  mounted() {
    this.init();
  },

  methods: {
    init() {
      this.formLabelAlign = this.rowData;
      // this.getCurrency();
      console.log('=====formLabelAlign:', this.formLabelAlign);
    },

    // async getCurrency() {
    //   const req = {};
    //   const res = await commonApi.getCurrency(req);
    //   console.log(res);
    //   this.currencyListData = res.list;
    // },
    async getCalculate() {
      const req = {
        productId: this.formLabelAlign.productId,
        userNumber: this.formLabelAlign.userNumber,
        monthNumber: this.formLabelAlign.monthNumber
      };
      const res = await orderApi.calculate(req);
      this.formLabelAlign.payableAmount = res.payableAmount;
    },

    userqtyChange() {
      this.getCalculate();
    },

    monthChange() {
      this.getCalculate();
    }
  }
};
</script>
<style lang="scss">
.order-form {
  .el-form-item__label {
    float: left;
    font-size: 16px;
    font-weight: bold;
    text-align: left;
    color: #292929;
    padding: 0;
  }

  .el-form-item__content {
    text-align: left;
    .el-textarea__inner {
      height: 80px;
    }
  }
}

.order-form-title {
  font-size: 24px;
  font-weight: bold;
  text-align: left;
  color: #292929;
  padding: 30px 0;
}

.line {
  height: 1px;
  background: #f4f4f4;
}

.dialog-class {
  border-radius: 14px !important;
  .el-dialog__header {
    background-color: #f4f4f4;
    border-top-left-radius: 14px;
    border-top-right-radius: 14px;
    padding: 50px 0 31px 50px;
  }

  .el-dialog__body {
    // height: 50vh;
    overflow: auto;
    padding: 40px 165px 0;
  }
}
</style>
